module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar sidebar-main"
  }, [_c('div', {
    staticClass: "sidebar-content"
  }, [_c('div', {
    staticClass: "sidebar-category sidebar-category-visible"
  }, [_c('div', {
    staticClass: "category-content no-padding"
  }, [_c('ul', {
    staticClass: "navigation navigation-main navigation-accordion"
  }, _vm._l((_vm.sidebarListCom), function(item, index) {
    return (_vm.sidebarListCom[index] && _vm.sidebarListCom[index].show) ? _c('li', {
      staticClass: "sidebar-item",
      class: {
        'active': _vm.sidebarListCom[index].set
      },
      on: {
        "click": function($event) {
          return _vm.sidebarSet(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('i', {
      class: _vm.sidebarListCom[index].icon
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.sidebarLan[index].text))])])]) : _vm._e()
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311ba92a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
// module id = 1090
// module chunks = 1